module.exports = {
      id: "comm-finance-usage",
      viewBox: "0 0 245.601 29.882",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-finance",
      toString: function () {
        return this.url;
      }
    }